var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component } from "vue-facing-decorator";
import { AboutClient } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from 'moment';
const aboutClient = new AboutClient(window.apiUrl);
const STATS_POLL_INTERVAL_MS = 5000;
let AboutAppTab = class AboutAppTab extends Vue {
    constructor() {
        super(...arguments);
        this.systemInfo = null;
        this.stats = null;
        this.downloadingLogs = false;
        this.statsTimer = null;
    }
    created() {
        this.loadSystemInfo();
        this.loadStats();
        this.startStatsPolling();
    }
    beforeUnmount() {
        this.stopStatsPolling();
    }
    loadSystemInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit("loadingChanged", true);
            try {
                this.systemInfo = yield aboutClient.getSystemInfo();
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.$emit("loadingChanged", false);
            }
        });
    }
    loadStats() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.stats = yield aboutClient.getSystemStats();
            }
            catch (ex) {
                // Silent failure on polling - don't disrupt the page.
                console.warn("Failed to refresh system stats:", ex);
            }
        });
    }
    startStatsPolling() {
        this.stopStatsPolling();
        this.statsTimer = window.setInterval(() => this.loadStats(), STATS_POLL_INTERVAL_MS);
    }
    stopStatsPolling() {
        if (this.statsTimer !== null) {
            window.clearInterval(this.statsTimer);
            this.statsTimer = null;
        }
    }
    get dataCollectUrl() {
        var _a;
        return (_a = this.systemInfo) === null || _a === void 0 ? void 0 : _a.dataCollectUrl;
    }
    get memoryUsedPercent() {
        var _a, _b, _c, _d;
        const total = (_b = (_a = this.stats) === null || _a === void 0 ? void 0 : _a.memoryTotalMb) !== null && _b !== void 0 ? _b : 0;
        const used = (_d = (_c = this.stats) === null || _c === void 0 ? void 0 : _c.memoryUsedMb) !== null && _d !== void 0 ? _d : 0;
        if (total <= 0)
            return 0;
        return Math.min(100, (used / total) * 100);
    }
    get cpuOverutilised() {
        var _a, _b;
        return ((_b = (_a = this.stats) === null || _a === void 0 ? void 0 : _a.cpuUsagePercent) !== null && _b !== void 0 ? _b : 0) > 70;
    }
    get memoryOverutilised() {
        return this.memoryUsedPercent > 70;
    }
    get statsLastUpdatedDisplay() {
        var _a;
        return ((_a = this.stats) === null || _a === void 0 ? void 0 : _a.lastUpdatedUnix)
            ? moment.unix(this.stats.lastUpdatedUnix).format('HH:mm:ss')
            : '�';
    }
    get infoLastUpdatedDisplay() {
        var _a;
        return ((_a = this.systemInfo) === null || _a === void 0 ? void 0 : _a.lastUpdatedUnix)
            ? moment.unix(this.systemInfo.lastUpdatedUnix).format('DD MMM YYYY HH:mm:ss')
            : '�';
    }
    formatPercent(value) {
        if (value === null || value === undefined)
            return '�';
        return `${value.toFixed(1)}%`;
    }
    formatMemoryGb(mb) {
        if (!mb || mb <= 0)
            return '�';
        return `${(mb / 1024).toFixed(2)} GB`;
    }
    copyDataCollectUrl() {
        if (!this.dataCollectUrl)
            return;
        navigator.clipboard.writeText(this.dataCollectUrl);
        Notifier.onOk("Copied");
    }
    downloadLogs() {
        return __awaiter(this, void 0, void 0, function* () {
            this.downloadingLogs = true;
            try {
                const response = yield aboutClient.downloadDiagnosticLogs();
                if (response === null || response === void 0 ? void 0 : response.data) {
                    DownloadUtil.handleFileDownload(response);
                }
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.downloadingLogs = false;
            }
        });
    }
};
AboutAppTab = __decorate([
    Component({
        name: "AboutAppTab",
        emits: ["loadingChanged"]
    })
], AboutAppTab);
export default AboutAppTab;
